module.exports = __webpack_public_path__ + "img/photo2.74d6822c.png";